import { HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { masks } from 'src/app/consts';
import { ListaUF } from 'src/app/consts/ListasSelects';
import { Usuario } from 'src/app/consts/usuario';
import { GeradorPlanilhaService } from 'src/app/services/gerador-planilha.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { ErrorPageComponent } from 'src/app/shared/custom-components/error-page/error-page.component';

@Component({
  selector: 'app-revisao-planilha',
  templateUrl: './revisao-planilha.component.html',
  styleUrls: ['./revisao-planilha.component.css']
})
export class RevisaoPlanilhaComponent implements OnInit {

  formulario: FormGroup
  public masks = masks;
  ufs = ListaUF
  arquivoSelecionado!: File;
  arquivosSelecionados: File[] = [];
  progresso = 0;
  enviando = false;
  FormDataArquivo: FormData
  UsuarioLogado: any

  constructor(public fb: FormBuilder,
    private geradorService: GeradorPlanilhaService,
    private dialog: MatDialog,
    private usuarioService: UsuarioService) {

    this.formulario = this.fb.group({
      cnpj: [null, Validators.required],
      cdUf: [null, Validators.required],
      NomeArquivo: [null, Validators.required]
    })

  }

  async ngOnInit(): Promise<void> {
    this.UsuarioLogado = await firstValueFrom(this.usuarioService.getLoggedUser())
    console.log(this.UsuarioLogado)
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    this.arquivoSelecionado = input.files[0];

    // 🚀 Chama o upload automaticamente
    this.upload();

    // (Opcional) Limpa o input para permitir selecionar o mesmo arquivo novamente
    input.value = '';
  }


  upload() {
    if (!this.arquivoSelecionado || this.enviando) {
      return;
    }
    this.FormDataArquivo = new FormData();
    this.FormDataArquivo.append('file', this.arquivoSelecionado);

    // Se quiser enviar outros dados do form junto
    this.FormDataArquivo.append('cnpj', this.formulario.value.cnpj);
    this.FormDataArquivo.append('cdUf', this.formulario.value.cdUf);



    this.formulario.patchValue({
      NomeArquivo: this.arquivoSelecionado.name
    })
  }

  postPlanilha(formData: FormData) {
    this.enviando = true;
    this.progresso = 0;

    this.geradorService.post(formData).subscribe({
      next: (event) => {

        // 📊 Progresso do upload
        if (event.type === HttpEventType.UploadProgress) {
          const percent = Math.round(
            (100 * event.loaded) / (event.total ?? 1)
          );

          this.progresso = Math.min(percent, 90);
        }

        // 📥 Resposta final (arquivo retornado)
        if (event.type === HttpEventType.Response) {

          const blob = event.body as Blob;

          // Nome do arquivo (pode vir do header também)
          const nomeArquivo = `Planilha_Tributacao_${this.formulario.value.cnpj}.xlsx`;

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');

          a.href = url;
          a.download = nomeArquivo;
          a.click();

          window.URL.revokeObjectURL(url);
          this.enviando = false;
          this.progresso = 100;
        }
      },
      error: (err) => {
        console.error('Erro no upload', err);
        this.abrirPaginaErro('erro', err)
        this.enviando = false;
      }
    });
  }

  abrirPaginaErro(tipo, mensagem) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      tipo: tipo,
      mensagem: mensagem,
    };

    this.dialog.open(ErrorPageComponent, dialogConfig);
  }

  limpar() {
    this.formulario.patchValue({
      cnpj: null,
      cdUf: null
    })

    this.FormDataArquivo = new FormData();
  }
}
